// Mock data for portfolio features

export const portfolioData = {
  personal: {
    name: "Kushagra Bhatia",
    title: "MS Finance (Fintech) | Software Engineer",
    email: "kushagra.bhatia@baruchmail.cuny.edu",
    phone: "(201)-312-2820",
    linkedin: "linkedin.com/in/kbhatia03",
    location: "New York, NY",
    bio: "I'm Kushagra — an engineer-turned-finance-professional who's passionate about using technology to reshape how people understand and interact with money. My journey started in electrical engineering, where I spent years solving complex technical problems and building software systems. After working as a Software Engineer at Hexaware Technologies on CRM solutions for EY, I realized my interests were expanding toward markets, behavior, and financial systems. That curiosity led me to New York City and to Baruch College, where I'm pursuing my MS in Finance with a FinTech focus. At Zicklin, I've immersed myself fully — working as a Graduate Teaching Assistant, mentoring new students, and representing the graduate community on the Curriculum Committee and the Student Assembly. These roles let me give back, build community, and help shape the academic experience for others. I love building things — especially AI-driven tools that sit at the intersection of finance and technology. Whether it's chatbots that demystify personal finance, dashboards that visualize market data, or pitch decks for disruptive startup ideas, I enjoy bringing ideas to life. My work reflects who I am: analytical, curious, community-focused, and always looking for better ways to create impact."
  },

  experience: [
    {
      id: 1,
      company: "Baruch College",
      role: "Graduate Teaching Assistant",
      location: "New York, NY",
      period: "Aug 2025 - Present",
      description: "Assisting professors with class operations and conducting research on historical market data using regression analysis to assess performance against benchmarks.",
      highlights: [
        "Supporting students with academic guidance",
        "Analyzing historical market and stock data",
        "Contributing to portfolio recommendations through data-driven research"
      ]
    },
    {
      id: 2,
      company: "Plootus",
      role: "Finance Intern",
      location: "New Haven, CT",
      period: "May 2025 - Jul 2025",
      description: "Supported a fintech startup focused on optimizing retirement plans through strategic content creation and AI development.",
      highlights: [
        "Delivered fully functional AI chatbot for retirement planning",
        "Built automation tools cutting manual processing time by 90%",
        "Enriched mutual fund database of 30,000+ entries, increasing data completeness by 20%",
        "Offered long-term advisory position with equity stake"
      ]
    },
    {
      id: 3,
      company: "Hexaware Technologies",
      role: "Software Engineer",
      location: "Chennai, India",
      period: "Jul 2022 - Jan 2025",
      description: "Administrative Contractor with EY on global CRM application, transitioning business processes to cloud technology.",
      highlights: [
        "Reduced incident resolution efforts by 50% through process guidelines",
        "Ensured 100% SLA adherence on resolutions",
        "Earned 2 promotions with recognition and awards",
        "Mentored team members to enhance productivity"
      ]
    }
  ],

  education: [
    {
      id: 1,
      institution: "Baruch College, Zicklin School of Business",
      degree: "MS in Finance",
      concentration: "Fintech",
      location: "New York, NY",
      gpa: "4.0",
      achievements: [
        "Winner of 4th Zicklin Graduate Student Case Competition (35+ teams)",
        "Completed Generative AI workshop led by NY Jobs CEO Council",
        "Graduate Student Representative for Curriculum Committee"
      ]
    },
    {
      id: 2,
      institution: "SRM Institute of Science and Technology",
      degree: "Bachelor of Technology",
      major: "Electrical and Electronics Engineering",
      minor: "Computer Science",
      location: "Chennai, India",
      gpa: "3.99",
      achievements: [
        "Best Final Year Project Award among 30+ teams"
      ]
    }
  ],

  projects: [
    {
      id: 1,
      name: "Financial Literacy Chatbot (FinBuddy)",
      description: "Developed a Node.js-based chatbot powered by OpenAI API to provide users with immediate, reliable financial insights.",
      technologies: ["Node.js", "OpenAI API", "JavaScript"],
      status: "Refining custom knowledge base to improve accuracy",
      highlights: [
        "Real-time financial insights",
        "Custom knowledge base integration",
        "Minimizing AI hallucinations"
      ]
    },
    {
      id: 2,
      name: "Financial Ratios Dashboard",
      description: "Created a Python program using yFinance to retrieve financials for companies and automatically produce Excel dashboards with key ratios and charts.",
      technologies: ["Python", "yFinance", "Streamlit", "Excel"],
      status: "Active - Integrating AI-driven insights module",
      highlights: [
        "Automated financial data retrieval",
        "Interactive Streamlit web app",
        "AI-driven predictive commentary"
      ]
    }
  ],

  skills: {
    programming: ["Python", "SQL", "C", "C++", "Node.js", "JavaScript"],
    aiTools: ["OpenAI API", "ChatGPT", "GitHub Copilot", "Generative AI"],
    finance: ["Financial Analysis", "Portfolio Management", "Retirement Planning", "Investment Analysis", "Market Research"],
    dataAnalysis: ["Regression Analysis", "Data Visualization", "Excel", "PowerBI", "yFinance"],
    tools: ["Git", "GitHub", "Microsoft Dynamics", "SAP", "ServiceNow", "Streamlit"],
    softSkills: ["Team Collaboration", "Mentoring", "Project Management", "Communication"]
  },

  certifications: [
    { name: "Generative AI Fundamentals", issuer: "New York Jobs CEO Council", year: "2025" },
    { name: "Bloomberg Finance Fundamentals", issuer: "Bloomberg", year: "2025" },
    { name: "MS Excel", issuer: "GUVI", year: "2025" },
    { name: "Financial Markets (with Honors)", issuer: "Yale University", year: "2024" },
    { name: "ServiceNow Certified System Administrator", issuer: "ServiceNow", year: "2023" },
    { name: "Microsoft Azure Fundamentals", issuer: "Microsoft", year: "2022" }
  ],

  researchPublications: [
    {
      id: 1,
      title: "Selection and Design of Energy Harvesting Circuit for Microbial Fuel Cell for Low Power Applications",
      year: "2024",
      description: "Research focused on optimizing energy harvesting circuits for microbial fuel cells in low-power application scenarios.",
      link: "https://link.springer.com/chapter/10.1007/978-981-99-9054-2_5",
      conference: "Springer"
    },
    {
      id: 2,
      title: "Design Guide for Small-Scale Grid-Connected PV System Using PVsyst Software",
      year: "2021",
      description: "Comprehensive design methodology for implementing small-scale photovoltaic systems with grid connectivity using PVsyst simulation software.",
      link: "https://link.springer.com/chapter/10.1007/978-981-16-4943-1_36",
      conference: "Springer"
    }
  ]
};

// Mock resume requests
export const mockResumeRequests = [
  {
    id: "req-001",
    name: "Sarah Johnson",
    email: "sarah.johnson@goldmansachs.com",
    company: "Goldman Sachs",
    message: "Interested in discussing fintech opportunities for our investment banking division.",
    status: "pending",
    createdAt: new Date(2025, 0, 15).toISOString()
  },
  {
    id: "req-002",
    name: "Michael Chen",
    email: "m.chen@jpmorgan.com",
    company: "JPMorgan Chase",
    message: "Looking for candidates with strong Python and finance background for our quant team.",
    status: "approved",
    createdAt: new Date(2025, 0, 12).toISOString(),
    approvedAt: new Date(2025, 0, 13).toISOString()
  }
];

// Mock coffee chat bookings
export const mockCoffeeChats = [
  {
    id: "chat-001",
    name: "Alex Rivera",
    email: "alex.rivera@columbia.edu",
    message: "Fellow Baruch student interested in discussing your fintech journey and the case competition!",
    preferredDate: "2025-02-01",
    preferredTime: "10:00 AM",
    createdAt: new Date(2025, 0, 14).toISOString()
  },
  {
    id: "chat-002",
    name: "Priya Sharma",
    email: "priya.s@nyu.edu",
    message: "Would love to chat about your experience transitioning from engineering to finance.",
    preferredDate: "2025-02-05",
    preferredTime: "2:00 PM",
    createdAt: new Date(2025, 0, 16).toISOString()
  }
];
